'use client'

import * as React from 'react'
import { useInView } from 'framer-motion'

type MarginValue = `${number}${'px' | '%'}`
type MarginType =
  | MarginValue
  | `${MarginValue} ${MarginValue}`
  | `${MarginValue} ${MarginValue} ${MarginValue}`
  | `${MarginValue} ${MarginValue} ${MarginValue} ${MarginValue}`

export function LoadWhenInViewport({
  children,
  fallback,
  margin = '0px',
  ...props
}: React.PropsWithChildren<
  React.ComponentProps<'div'> & {
    margin?: MarginType
    fallback?: React.ReactNode
  }
>) {
  const ref = React.useRef<HTMLDivElement>(null)
  const isInViewPort = useInView(ref, { once: true, margin })

  return (
    <div ref={ref} {...props}>
      {isInViewPort ? children : fallback}
    </div>
  )
}
